/**
 * 起動時の後始末（アプリを開いたときに 1 度だけ走らせる）。
 *
 * 2 つを順に行う:
 *  1. **未送信ドラフトの掃き出し**（`recoverPendingDrafts`）。編集画面を開かなくても
 *     前回の続きがサーバーへ届くようにする。三層耐久性の最後の受け皿。
 *  2. **送信済みで古いドラフトの掃除**（`pruneCleanDrafts`）。1 の後に行うのが要点で、
 *     順序が逆だと「まだ送っていないのに古い」ものを消しかねない。
 *
 * 絶対規則2 に直結するので、**掃除は「送信済み（dirty=false）かつ 7 日以上前」だけ**。
 * 判定は `shouldPruneDraft`（純粋関数）にあり、ユニットテストで固定してある。
 *
 * どちらも失敗しても起動を妨げない。次の起動で再挑戦すればよい。
 */

import { pruneCleanDrafts } from '@app/storage/draft-buffer';
import { recoverPendingDrafts } from '@app/save/useNoteEditor';

export interface StartupMaintenanceResult {
  /** サーバーへ送り出せた未送信ドラフトの件数。 */
  recovered: number;
  /** 端末から掃除した送信済みドラフトの件数。 */
  pruned: number;
}

export async function runStartupMaintenance(): Promise<StartupMaintenanceResult> {
  const recovered = await recoverPendingDrafts().catch(() => 0);
  // 掃き出しの後に掃除する。逆順にすると、送信前のものを古いと判断し得る。
  const pruned = await pruneCleanDrafts().catch(() => 0);
  return { recovered, pruned };
}
